import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'monthsLongName'
})
export class DateMonthLongNamePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: number): string | number {
    switch (value) {
      case 1:
        return this.translateService.instant('months.long.january');
      case 2:
        return this.translateService.instant('months.long.february');
      case 3:
        return this.translateService.instant('months.long.march');
      case 4:
        return this.translateService.instant('months.long.april');
      case 5:
        return this.translateService.instant('months.long.may');
      case 6:
        return this.translateService.instant('months.long.june');
      case 7:
        return this.translateService.instant('months.long.july');
      case 8:
        return this.translateService.instant('months.long.august');
      case 9:
        return this.translateService.instant('months.long.september');
      case 10:
        return this.translateService.instant('months.long.october');
      case 11:
        return this.translateService.instant('months.long.november');
      case 12:
        return this.translateService.instant('months.long.december');
      default:
        return value;
    }
  }
}
